import { useEffect, useMemo, useRef, useState } from "react";

const PANEL_CSS = `
  .c2h-why{--navy:#011B47; --navy2:#022356; --teal:#13AFDC; --green:#8FD67A; --green2:#5C9E46;
    --text:#E6EDF6; --muted:#A9B7CC; --card:rgba(255,255,255,.06); --line:rgba(255,255,255,.12);
    width:100%;max-width:560px;position:relative;font-family:'Work Sans',system-ui,-apple-system,Segoe UI,Roboto,Arial,sans-serif;color:var(--text)}
  .c2h-why *{box-sizing:border-box;margin:0;padding:0}
  .c2h-why .eyebrow{font-size:12px;font-weight:700;letter-spacing:.2em;color:var(--green);margin-bottom:14px}
  .c2h-why .scene{position:relative;border-radius:22px;overflow:hidden;background:
      radial-gradient(120% 90% at 70% 10%,rgba(19,175,220,.25),transparent 60%),
      linear-gradient(180deg,#05306f 0%,#022356 100%);
    border:1px solid var(--line);height:300px}
  .c2h-why .scene svg{position:absolute;inset:0;width:100%;height:100%}
  .c2h-why .air{stroke:#BFEFFF;stroke-width:2.2;fill:none;stroke-linecap:round;stroke-dasharray:14 180;opacity:.9;animation:air 3.2s linear infinite}
  .c2h-why .air.a2{animation-delay:-.9s;opacity:.6}.c2h-why .air.a3{animation-delay:-1.8s;opacity:.75}.c2h-why .air.a4{animation-delay:-2.5s;opacity:.5}
  @keyframes air{from{stroke-dashoffset:194}to{stroke-dashoffset:0}}
  .c2h-why .fan{transform-origin:236px 92px;animation:spin 1.6s linear infinite}
  @keyframes spin{to{transform:rotate(360deg)}}
  .c2h-why .water{animation:fill 4s ease-in-out infinite alternate}
  @keyframes fill{from{transform:translateY(60px)}to{transform:translateY(0)}}
  .c2h-why .steam path{fill:none;stroke:rgba(255,255,255,.75);stroke-width:3;stroke-linecap:round;opacity:0;animation:steam 3s ease-out infinite}
  .c2h-why .steam path:nth-child(2){animation-delay:1s}.c2h-why .steam path:nth-child(3){animation-delay:2s}
  @keyframes steam{0%{opacity:0;transform:translateY(10px)}30%{opacity:.8}100%{opacity:0;transform:translateY(-26px)}}
  .c2h-why .drop{fill:#13AFDC;animation:drop 1.4s ease-in infinite}
  @keyframes drop{0%{transform:translateY(0);opacity:1}80%{opacity:1}100%{transform:translateY(34px);opacity:0}}
  .c2h-why .leaf{transform-origin:center;animation:leaf 6s ease-in-out infinite}
  .c2h-why .leaf.l2{animation-delay:-2s}.c2h-why .leaf.l3{animation-delay:-4s}
  @keyframes leaf{0%{transform:translate(0,0) rotate(0)}50%{transform:translate(-14px,-18px) rotate(-18deg)}100%{transform:translate(0,0) rotate(0)}}
  .c2h-why .gauge{animation:gauge 4s ease-in-out infinite alternate}
  @keyframes gauge{from{stroke-dashoffset:120}to{stroke-dashoffset:18}}
  .c2h-why .temp{font:700 15px 'Work Sans',Arial,sans-serif;fill:#fff}
  .c2h-why .tag{position:absolute;background:rgba(255,255,255,.95);color:var(--navy);border-radius:999px;padding:7px 12px;font-size:12px;font-weight:700;box-shadow:0 10px 24px rgba(0,0,0,.25);display:flex;gap:6px;align-items:center;animation:float 4s ease-in-out infinite}
  .c2h-why .tag i{width:8px;height:8px;border-radius:50%;background:var(--green);box-shadow:0 0 0 0 rgba(143,214,122,.7);animation:ping 1.8s infinite}
  .c2h-why .t1{left:18px;top:18px}.c2h-why .t2{right:18px;top:18px;animation-delay:-1.3s}.c2h-why .t3{right:18px;bottom:18px;animation-delay:-2.6s}
  @keyframes float{50%{transform:translateY(-6px)}}
  @keyframes ping{70%{box-shadow:0 0 0 8px rgba(143,214,122,0)}100%{box-shadow:0 0 0 0 rgba(143,214,122,0)}}
  .c2h-why .toggle{display:flex;background:var(--card);border:1px solid var(--line);border-radius:999px;padding:4px;margin:16px 0 12px}
  .c2h-why .toggle button{flex:1;border:0;background:transparent;color:var(--muted);font:600 13px inherit;padding:10px;border-radius:999px;cursor:pointer;transition:.3s}
  .c2h-why .toggle button.on{background:var(--teal);color:var(--navy)}
  .c2h-why .compare{display:grid;grid-template-columns:repeat(3,1fr);gap:10px}
  .c2h-why .cmp{background:var(--card);border:1px solid var(--line);border-radius:14px;padding:14px 12px;text-align:center;transition:.4s}
  .c2h-why .cmp b{display:block;font-family:'Playfair Display',Georgia,serif;font-size:22px;color:#fff;transition:.4s}
  .c2h-why .cmp span{font-size:11.5px;color:var(--muted)}
  .c2h-why .cmp.good b{color:var(--green)}
  .c2h-why .grid{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin-top:18px}
  .c2h-why .card{background:var(--card);border:1px solid var(--line);border-radius:16px;padding:18px;transition:transform .25s,border-color .25s,background .25s;cursor:default}
  .c2h-why .card:hover{transform:translateY(-4px);border-color:rgba(19,175,220,.6);background:rgba(19,175,220,.08)}
  .c2h-why .ic{width:34px;height:34px;border-radius:50%;background:rgba(19,175,220,.16);display:grid;place-items:center;margin-bottom:10px}
  .c2h-why .card b{display:block;font-family:'Playfair Display',Georgia,serif;font-size:32px;line-height:1;margin-bottom:6px;color:#fff}
  .c2h-why .card span{font-size:13px;color:var(--muted);line-height:1.4}
  .c2h-why h3{font-family:'Playfair Display',Georgia,serif;font-size:22px;margin:26px 0 14px;color:#fff}
  .c2h-why .steps{position:relative}
  .c2h-why .rail{position:absolute;left:17px;top:18px;bottom:18px;width:2px;background:rgba(255,255,255,.12)}
  .c2h-why .rail i{position:absolute;left:0;top:0;width:2px;height:0;background:linear-gradient(var(--teal),var(--green));transition:height 1.6s ease}
  .c2h-why.in .rail i{height:100%}
  .c2h-why .st{display:flex;gap:16px;margin-bottom:16px;position:relative;opacity:.35;transition:opacity .5s}
  .c2h-why.in .st{opacity:1}.c2h-why.in .st:nth-child(3){transition-delay:.5s}.c2h-why.in .st:nth-child(4){transition-delay:1s}
  .c2h-why .n{flex:0 0 36px;height:36px;border-radius:50%;background:var(--teal);color:var(--navy);font-weight:700;display:grid;place-items:center;box-shadow:0 0 0 6px var(--navy)}
  .c2h-why .st b{font-size:15px;display:block;margin:2px 0 3px;color:#fff}.c2h-why .st p{font-size:13px;color:var(--muted);line-height:1.45}
  .c2h-why .note{display:flex;gap:16px;align-items:center;border-left:4px solid var(--green);background:rgba(143,214,122,.08);border-radius:12px;padding:16px 18px;margin-top:6px}
  .c2h-why .days{text-align:center;min-width:78px}
  .c2h-why .days b{display:block;font-family:'Playfair Display',Georgia,serif;font-size:34px;color:var(--green);line-height:1}
  .c2h-why .days span{font-size:10.5px;letter-spacing:.12em;color:var(--muted)}
  .c2h-why .note p{font-size:13.5px;line-height:1.5}
  .c2h-why .sp{font-size:11px;color:#8A97AD;margin-top:12px;line-height:1.5}
  .c2h-why .reveal{opacity:0;transform:translateY(14px);transition:opacity .6s,transform .6s}
  .c2h-why.in .reveal{opacity:1;transform:none}
  @media (prefers-reduced-motion:reduce){.c2h-why *{animation:none!important;transition:none!important}}
`;

const MODES = {
  hp: { fuel: ["Air", true], gas: ["$0", true], rule: ["2027 ready", true] },
  gas: { fuel: ["Gas", false], gas: ["Ongoing", false], rule: ["Phasing out", false] },
};

const CMP_LABELS = {
  fuel: "Energy source",
  gas: "Gas supply for hot water",
  rule: "Victoria's new rules",
};

const STATS = [
  {
    count: 1,
    suffix: " day",
    text: "Most installs done in a single day",
    icon: (
      <>
        <circle cx="12" cy="12" r="9" />
        <path d="M12 7v5l3 2" />
      </>
    ),
  },
  {
    count: 3,
    suffix: "",
    text: "Government rebates handled for you",
    icon: (
      <>
        <path d="M6 3h9l3 3v15H6z" />
        <path d="M9 11h6M9 15h6" />
      </>
    ),
  },
  {
    count: 7,
    suffix: " yr",
    text: "Rinnai cylinder warranty*",
    icon: <path d="M12 3l7 3v6c0 4-3 7-7 9-4-2-7-5-7-9V6z" />,
  },
  {
    count: 100,
    suffix: "%",
    text: "Licensed & insured plumbers",
    icon: <path d="M5 12l4 4 10-10" />,
  },
];

const WhyC2HPanel = () => {
  const rootRef = useRef(null);
  const [inView, setInView] = useState(false);
  const [mode, setMode] = useState("hp");

  const days = useMemo(() => {
    const d = Math.ceil(
      (new Date("2027-03-01T00:00:00+11:00") - new Date()) / 864e5
    );
    return d > 0 ? d : "Now";
  }, []);

  // Reveal + count-up once when the panel scrolls into view
  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;
    const countUp = () => {
      root.querySelectorAll("[data-count]").forEach((el) => {
        const end = +el.dataset.count;
        const suf = el.dataset.suffix || "";
        let t0 = null;
        const step = (ts) => {
          if (!t0) t0 = ts;
          const p = Math.min((ts - t0) / 1200, 1);
          el.textContent = Math.round(end * (1 - Math.pow(1 - p, 3))) + suf;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      });
    };
    if ("IntersectionObserver" in window) {
      const o = new IntersectionObserver(
        (entries) => {
          entries.forEach((e) => {
            if (e.isIntersecting) {
              setInView(true);
              countUp();
              o.disconnect();
            }
          });
        },
        { threshold: 0.15 }
      );
      o.observe(root);
      return () => o.disconnect();
    }
    setInView(true);
    countUp();
  }, []);

  return (
    <div
      ref={rootRef}
      data-testid="why-c2h-panel"
      className={`c2h-why${inView ? " in" : ""}`}
    >
      <style>{PANEL_CSS}</style>

      <div className="eyebrow">HOW A RINNAI HEAT PUMP WORKS</div>

      <div className="scene">
        <svg viewBox="0 0 560 300" preserveAspectRatio="xMidYMid slice" aria-hidden="true">
          <ellipse cx="280" cy="292" rx="300" ry="26" fill="#0A3A2A" />
          <path d="M0 285 Q140 265 280 280 T560 275 V300 H0Z" fill="#2f6b24" />
          <path className="air" d="M20 70 C90 60 140 95 200 88" />
          <path className="air a2" d="M10 110 C80 105 130 120 200 100" />
          <path className="air a3" d="M30 40 C100 45 150 70 205 80" />
          <path className="air a4" d="M15 140 C90 135 140 130 200 112" />
          <g transform="translate(176,40)">
            <rect x="0" y="0" width="120" height="70" rx="14" fill="#2B3138" />
            <rect x="70" y="10" width="42" height="50" rx="6" fill="#1b2026" />
            <g transform="translate(91,35)">
              <g className="fan" style={{ transformOrigin: "0 0" }}>
                <path d="M0 0 L0 -18 A18 18 0 0 1 15 -9Z" fill="#13AFDC" />
                <path d="M0 0 L15 9 A18 18 0 0 1 -1 18Z" fill="#13AFDC" />
                <path d="M0 0 L-15 9 A18 18 0 0 1 -15 -9Z" fill="#13AFDC" />
              </g>
              <circle r="4" fill="#fff" />
            </g>
            <rect x="10" y="12" width="46" height="24" rx="4" fill="#0f141a" />
            <text x="33" y="29" textAnchor="middle" className="temp" style={{ fontSize: "12px" }}>60°C</text>
            <clipPath id="tankclip"><rect x="6" y="70" width="108" height="170" rx="18" /></clipPath>
            <rect x="6" y="70" width="108" height="170" rx="18" fill="#E9E5DC" />
            <g clipPath="url(#tankclip)">
              <g className="water">
                <path d="M0 160 Q30 150 60 160 T120 160 V260 H0Z" fill="#13AFDC" opacity=".35" />
                <path d="M0 168 Q30 178 60 168 T120 168 V260 H0Z" fill="#E8573F" opacity=".25" />
              </g>
            </g>
            <text x="60" y="104" textAnchor="middle" style={{ font: "700 15px Arial", fill: "#d7262b" }}>Rinnai</text>
            <rect x="30" y="150" width="20" height="30" rx="3" fill="#fff" stroke="#cfcac0" />
            <rect x="16" y="236" width="88" height="10" rx="3" fill="#9aa0a6" />
          </g>
          <path d="M296 200 H370 V120 H420" stroke="#9aa0a6" strokeWidth="6" fill="none" strokeLinecap="round" />
          <path d="M420 110 h26 a6 6 0 0 1 6 6 v6 h-32z" fill="#c9ced3" />
          <circle className="drop" cx="430" cy="134" r="3" />
          <circle className="drop" cx="438" cy="134" r="3" style={{ animationDelay: ".45s" }} />
          <circle className="drop" cx="446" cy="134" r="3" style={{ animationDelay: ".9s" }} />
          <g className="steam" transform="translate(422,150)">
            <path d="M6 30 q-8 -10 0 -20 q8 -10 0 -20" />
            <path d="M18 30 q-8 -10 0 -20 q8 -10 0 -20" />
            <path d="M30 30 q-8 -10 0 -20 q8 -10 0 -20" />
          </g>
          <g transform="translate(70,240)">
            <circle r="26" fill="none" stroke="rgba(255,255,255,.15)" strokeWidth="6" />
            <circle className="gauge" r="26" fill="none" stroke="#8FD67A" strokeWidth="6" strokeLinecap="round" strokeDasharray="163" strokeDashoffset="120" transform="rotate(-90)" />
            <text y="5" textAnchor="middle" className="temp" style={{ fontSize: "11px" }}>ECO</text>
          </g>
          <g className="leaf"><path d="M500 90 q18 -18 30 -2 q-16 18 -30 2z" fill="#8FD67A" /></g>
          <g className="leaf l2"><path d="M470 80 q14 -14 24 -2 q-12 14 -24 2z" fill="#5C9E46" /></g>
          <g className="leaf l3"><path d="M520 140 q12 -12 22 -2 q-11 12 -22 2z" fill="#8FD67A" /></g>
        </svg>
        <div className="tag t1"><i></i>Heats water from the air</div>
        <div className="tag t2"><i></i>No gas needed</div>
        <div className="tag t3"><i></i>Rinnai, installed by C2H</div>
      </div>

      <div data-testid="why-explainer-steps" className="mt-5">
        <div className="st">
          <div className="n">1</div>
          <div>
            <b>Draws in warm air</b>
            <p>A quiet fan pulls in the outside air, even on cool Melbourne days.</p>
          </div>
        </div>
        <div className="st">
          <div className="n">2</div>
          <div>
            <b>Captures the heat</b>
            <p>A refrigerant inside the unit soaks up heat from that air, and a compressor boosts it to a higher temperature.</p>
          </div>
        </div>
        <div className="st" style={{ marginBottom: 0 }}>
          <div className="n">3</div>
          <div>
            <b>Heats your water</b>
            <p>That heat passes into the water in the tank, so you get hot water using a fraction of the energy of a standard electric system, and no gas.</p>
          </div>
        </div>
      </div>

      <div className="toggle" role="tablist">
        <button
          type="button"
          className={mode === "hp" ? "on" : ""}
          onClick={() => setMode("hp")}
          data-testid="why-toggle-hp"
        >
          Rinnai heat pump
        </button>
        <button
          type="button"
          className={mode === "gas" ? "on" : ""}
          onClick={() => setMode("gas")}
          data-testid="why-toggle-gas"
        >
          Old gas system
        </button>
      </div>
      <div className="compare">
        {["fuel", "gas", "rule"].map((k) => {
          const [val, good] = MODES[mode][k];
          return (
            <div
              key={k}
              className={`cmp${good ? " good" : ""}`}
              data-testid={`why-cmp-${k}`}
            >
              <b>{val}</b>
              <span>{CMP_LABELS[k]}</span>
            </div>
          );
        })}
      </div>

      <div className="grid reveal">
        {STATS.map((s) => (
          <div className="card" key={s.text}>
            <div className="ic">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#13AFDC" strokeWidth="2">
                {s.icon}
              </svg>
            </div>
            <b data-count={s.count} data-suffix={s.suffix}>
              {s.count}
              {s.suffix}
            </b>
            <span>{s.text}</span>
          </div>
        ))}
      </div>

      <h3 className="reveal">How it works</h3>
      <div className="steps">
        <div className="rail"><i></i></div>
        <div className="st">
          <div className="n">1</div>
          <div>
            <b>Check your eligibility</b>
            <p>Answer a few quick questions. It takes under a minute.</p>
          </div>
        </div>
        <div className="st">
          <div className="n">2</div>
          <div>
            <b>Get your Rinnai quote</b>
            <p>We call you, confirm the right size and give you a clear price.</p>
          </div>
        </div>
        <div className="st">
          <div className="n">3</div>
          <div>
            <b>We install &amp; handle rebates</b>
            <p>Old system out, new Rinnai in, paperwork done.</p>
          </div>
        </div>
      </div>

      <div className="note reveal">
        <div className="days">
          <b data-testid="why-days">{days}</b>
          <span>DAYS TO GO</span>
        </div>
        <p>
          <b style={{ color: "var(--green)" }}>From 1 March 2027</b>, a failed
          gas hot water system in Victoria must be replaced with an efficient
          electric one. Upgrade on your terms, not in an emergency.
        </p>
      </div>
      <div className="sp">
        *Cylinder warranty. Terms apply. See Rinnai warranty for details.
      </div>
    </div>
  );
};

export default WhyC2HPanel;
